import axios from './axiosConfig';
import { AxiosPromise } from 'axios';
import { TutorScheduleMasterResponse } from '../models/TutorScheduleMaster';

export const list = (id: number): AxiosPromise<TutorScheduleMasterResponse[]> => {
  return axios.get(`/api/tutor/${id}/schedule/master`);
};